import { render, staticRenderFns } from "./roofing-home.vue?vue&type=template&id=051ebf7b&scoped=true"
import script from "./roofing-home.vue?vue&type=script&lang=js"
export * from "./roofing-home.vue?vue&type=script&lang=js"
import style0 from "./roofing-home.vue?vue&type=style&index=0&id=051ebf7b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051ebf7b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VImg,VRow})
